module.exports = __webpack_public_path__ + "img/customer2_7.05815561.png";